import { render } from "./Tool.vue?vue&type=template&id=6beb585b"
import script from "./Tool.vue?vue&type=script&lang=js"
export * from "./Tool.vue?vue&type=script&lang=js"

import "./Tool.vue?vue&type=style&index=0&id=6beb585b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__